import * as Yup from 'yup'
import moment from 'moment'
import { getDateByUserFormat, getMinDate, today } from '../../../../helpers/timeHelper'

const toDate = (value) => (value && typeof value.toDate === 'function' ? value.toDate() : value)

const isTruthyGdpr = (v) => v === true || v === 1

export const isGdprPassportType = (type, passportTypes) => {
  if (!type || type.id == null) return false

  if (isTruthyGdpr(type.is_gdpr)) return true

  const passportType = passportTypes?.find((p) => p.id == type.id)
  return isTruthyGdpr(passportType?.is_gdpr)
}

export const initialValues = {
  type: { name: '', id: null },
  country: { name: '', id: null },
  firstName: '',
  lastName: '',
  middleName: '',
  date_of_issue: null,
  date_of_expire: null,
  number: '',
  street: { name: '', id: null },
  city: { name: '', id: null },
  issuedBy: '',
}

export const getValidationSchema = (dateFormat, isGdpr = false) => {
  const baseSchema = {
    type: Yup.object().shape({
      id: Yup.number().required('Field is required').nullable(),
    }),
    country: Yup.object().shape({
      id: Yup.number().required('Field is required').nullable(),
    }),
    firstName: Yup.string().trim().required('Field is required'),
    lastName: Yup.string().trim().required('Field is required'),
    date_of_expire: Yup.mixed()
      .transform(toDate)
      .test('is-valid-date', `Invalid date format, valid - ${dateFormat}`, (value) => !value || moment(value).isValid())
      .nullable(),
  }

  const fullSchema = {
    ...baseSchema,
    ...(!isGdpr && { number: Yup.string().trim().required('Field is required') }),
    city: Yup.object().shape({
      id: Yup.mixed().test('Check city', 'Select city from list', function (value) {
        const { name } = this.parent

        return name ? Boolean(value) : true
      }),
    }),
    street: Yup.object().shape({
      id: Yup.mixed().test('Check street', 'Select street from list', function (value) {
        const { name } = this.parent

        return name ? Boolean(value) : true
      }),
    }),
    issuedBy: Yup.string().trim(),
    date_of_issue: Yup.date()
      .min(getMinDate, `Min date is ${getDateByUserFormat(getMinDate)}`)
      .max(today, `Max date is ${getDateByUserFormat(today)}`)
      .typeError(`Invalid date format, valid - ${dateFormat}`)
      .required('Field is required')
      .nullable(),
  }

  return Yup.object().shape(fullSchema)
}
